export default class License {
  id?: number;
  number: string;
  state: string;
  can: any;
}